import { Component, OnInit, Input, Output, EventEmitter, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import Moment from "moment";

import { ApiService } from "src/app/api.service";
import { DvsUtilities } from "src/app/dvs-utilities";
import { DatetimePipe } from "src/app/pipes";
import { DayPickerComponent } from "src/app/shared/day-picker/day-picker.component";
import { AssemblyConfig, APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-raw-select",
	templateUrl: "./raw-select.component.html",
	styleUrls: ["./raw-select.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [DayPickerComponent, FormsModule, DatetimePipe]
})
export class RawSelectComponent implements OnInit {
	private api = inject(ApiService);

	@Input()
	asset: APIResults.FleetAsset;
	@Input()
	fleet: APIResults.Fleet;
	@Input()
	component: AssemblyConfig.Component;
	@Input()
	shaft: AssemblyConfig.Shaft;
	@Output()
	rawSelected = new EventEmitter();

	pairs: true;

	rawids: APIResults.RawSinglesResult[] | APIResults.RawPairsResult[] = undefined;
	selected: APIResults.RawSinglesResult | APIResults.RawPairsResult;

	selectedDate: string;
	allowedDates: NgbDateStruct[] = undefined;

	rawChange(raw: APIResults.RawSinglesResult | APIResults.RawPairsResult) {
		this.rawSelected.emit(raw);
	}

	dateChange() {
		this.refreshRaws();
	}

	async ngOnInit() {
		this.allowedDates = undefined;
		this.rawids = undefined;
		this.rawSelected.emit(null);
		if (this.component.type === "tach" || this.component.type === "sensor") {
			this.allowedDates = await this.api.GetComponentRawSingleDates(this.asset.asset_id, this.component.id);
		} else if (this.component.type === "gear" || this.component.type === "bearing") {
			this.allowedDates = await this.api.GetComponentRawPairDates(this.asset.asset_id, this.shaft.id);
		} else {
			this.allowedDates = await this.api.GetComponentRawPairDates(this.asset.asset_id, this.component.id);
		}
		if (this.allowedDates && this.allowedDates.length) {
			this.selectedDate = DvsUtilities.FormatNgbDate(this.allowedDates[this.allowedDates.length - 1], null);
		}
		await this.refreshRaws();
	}

	async refreshRaws() {
		if (!this.selectedDate) return;
		const start = this.selectedDate;
		const end = Moment(this.selectedDate).add(1, "days").format("YYYY-MM-DD");
		this.rawSelected.emit(undefined);
		if (this.asset && this.component) {
			let getter: Promise<any>;

			if (this.component.type === "tach" || this.component.type === "sensor") {
				getter = this.api.GetComponentRawSingles(this.asset.asset_id, this.component.id, start, end);
			} else if (this.component.type === "gear" || this.component.type === "bearing") {
				getter = this.api.GetComponentRawPairs(this.asset.asset_id, this.shaft.id, start, end);
			} else {
				getter = this.api.GetComponentRawPairs(this.asset.asset_id, this.component.id, start, end);
			}
			try {
				this.rawids = undefined;
				const result = await getter;
				this.rawids = result;
				// Autoselect first (newest) raw
				if (result && result.length) {
					this.selected = result[0];
					this.rawChange(result[0]);
				}
			} catch (err) {
				console.error("Couldn't load tach raws");
				console.log(err);
				// TODO: Error handling
			}
		}
	}
}
